import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; // Import Firebase Authentication
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBScpAnfO9P3Fnyq2utJlVe350qWEBMQlE",
  authDomain: "cozy-bud.firebaseapp.com",
  databaseURL: "https://cozy-bud-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "cozy-bud",
  storageBucket: "cozy-bud.appspot.com",
  messagingSenderId: "605863308698",
  appId: "1:605863308698:web:691476f1ccceaeebb25e23"
};

 const config = initializeApp(firebaseConfig);
const auth = getAuth(config);
const db = getFirestore(config);

export { auth, db };